import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import UI components
import { Checkbox, TimePicker } from '@geneui/components';
// Import constants
import { l } from 'constants/common';

const TimePickerWithHasTimeToggle = ({ timeValue, setTime }) => {
    const { t } = useTranslation();

    const handleTimePicker = (event) => {
        const { value } = event.target;
        setTime({ ...timeValue, value });
    };

    const handleHasTime = (event) => {
        const { checked } = event.target;
        setTime({ ...timeValue, hasTime: checked });
    };

    return (
        <>
            <div className="pt-25 pb-10 pl-10 crm-date-form-simple-tab__has-time">
                <Checkbox label={t(l.ConsiderTime)} onChange={handleHasTime} checked={timeValue.hasTime} />
                <i className={'bc-icon-info'} />
            </div>
            {timeValue.hasTime && (
                <TimePicker
                    className={'crm-date-form-simple-tab_time-picker'}
                    showSeconds={false}
                    minuteFormat={'mm'}
                    hourFormat={'HH'}
                    onChange={handleTimePicker}
                    value={timeValue.value}
                />
            )}
        </>
    );
};

TimePickerWithHasTimeToggle.propTypes = {
    timeValue: PropTypes.object,
    setTime: PropTypes.func,
};

export default memo(TimePickerWithHasTimeToggle);
